import { render, staticRenderFns } from "./param-items.vue?vue&type=template&id=c3c4dce8"
import script from "./param-items.vue?vue&type=script&lang=ts"
export * from "./param-items.vue?vue&type=script&lang=ts"
import style0 from "./param-items.vue?vue&type=style&index=0&id=c3c4dce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports